import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import type { AccordionItem } from "@/components/ui/Accordion";
import { Prose } from "@/components/ui/Prose";
import { Text } from "@/components/ui/sections/Text";
import type {
	EmployeeStoryblok,
	FaqDetailsPageStoryblok,
	TextStoryblok,
} from "@/generated/sb/sb-types";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

type ResolvedFaqItem = {
	uuid: string;
	content: FaqDetailsPageStoryblok;
};

const resolvedFaqItems = (items: unknown[] | undefined): ResolvedFaqItem[] =>
	(items ?? []).filter((item) => typeof item !== "string") as ResolvedFaqItem[];

export const TextBlok = ({ blok, preview }: BlokProps<TextStoryblok>) => {
	const alignment = blok.alignment || "center";

	const accordion: AccordionItem[] = resolvedFaqItems(blok.accordion).map((item) => ({
		id: item.uuid,
		title: item.content.question,
		content: <Prose>{renderRichText(item.content.answer)}</Prose>,
	}));

	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok}>
			<Text
				alignment={alignment}
				bg={bg}
				heading={blok.heading || undefined}
				sideLabel={blok.sideLabel || undefined}
				body={renderRichText(blok.body)}
				quoteCaption={blok.quoteCaption || undefined}
				quoteText={blok.quoteText || undefined}
				accordion={accordion.length > 0 ? accordion : undefined}
				asset={blok.asset}
				contact={blok.contact}
				secondary={blok.secondary}
				preview={preview}
			/>
		</BlokWrap>
	);
};
